import {gql} from 'graphql-request';
import {useGqlRequest} from '@/api/request';
import {AnalysisItem} from '@/map/@types';
import {FootTrafficResult, FootTrafficVars} from '@/map/@types/foot-traffic';
import {AreaOverlayType} from '@/map/enums';
import {useQuery} from '@tanstack/react-query';
import {getAreaQueryVariables} from './variables';

export const useFootTraffic = (
  item: AnalysisItem,
  footTrafficVars?: FootTrafficVars
) => {
  const id = item?.id;
  const enabled = !!id && !!footTrafficVars;

  const query =
    item.type === AreaOverlayType.CIRCLE
      ? QUERY_FOOT_TRAFFIC_BY_POINT
      : QUERY_FOOT_TRAFFIC_BY_POLYGON;

  const request = useGqlRequest({
    query,
  });

  const queryFn = ():
    | undefined
    | Promise<{
        result?: FootTrafficResult;
      }> => {
    const variant = !!footTrafficVars &&
      Object.keys(footTrafficVars).length > 0 && {
        ...footTrafficVars,
        ...getAreaQueryVariables(item),
      };

    if (!variant) {
      return;
    }

    return request(variant);
  };

  const select = (data?: {result?: FootTrafficResult}) => data?.result;

  return useQuery({
    enabled,
    queryKey: ['map', 'analytics', id, 'foot-traffic', footTrafficVars],
    queryFn,
    select,
  });
};

const footTrafficSubfields = `
  dataIndex
  result {
    baseDate
    topPercent
    value # 유동인구
    tilePolygon {
      coordinates
      type
    }
  }
`;

const QUERY_FOOT_TRAFFIC_BY_POINT = gql`
query footTrafficByPoint($lat: Float!, $lng: Float!, $radius: Float!, $timeCode: FootTrafficTimeCode, $gender: FootTrafficGender, $dayType: FootTrafficDayType, $ageGroup: FootTrafficAgeGroup) {
  result: footTrafficByPoint(lat: $lat, lng: $lng, radius: $radius, timeCode: $timeCode, gender: $gender, dayType: $dayType, ageGroup: $ageGroup) {
    ${footTrafficSubfields}
  }
}
`;

const QUERY_FOOT_TRAFFIC_BY_POLYGON = gql`
query footTrafficByPolygon($ageGroup: FootTrafficAgeGroup, $dayType: FootTrafficDayType, $gender: FootTrafficGender, $timeCode: FootTrafficTimeCode, $polygon: GeoPolygonArgs!) {
  result: footTrafficByPolygon(ageGroup: $ageGroup, dayType: $dayType, gender: $gender, timeCode: $timeCode, polygon: $polygon) {
    ${footTrafficSubfields}
  }
}
`;
